import ReportListPanel from './container';

export default ReportListPanel;



// WEBPACK FOOTER //
// ./src/views/ReportListPanel/index.js